export default __webpack_public_path__ + "static/media/saudi.c8692dde.jpg";